// extracted by mini-css-extract-plugin
module.exports = {"banner":"Cookie_banner__1UGTS"};